var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hs-tag",class:{actived: _vm.active}},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.subTitle)?_c('div',{staticClass:"sub-title"},[_c('span',{directives:[{name:"font-size-scale",rawName:"v-font-size-scale",value:(0.583),expression:"0.583"}]},[_vm._v(_vm._s(_vm.subTitle))])]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }